export default __webpack_public_path__ + "static/media/hht2_storybook_02.4d3d2b8b.png";